import { render, staticRenderFns } from "./ReportLead.vue?vue&type=template&id=3f596a8b&scoped=true&"
import script from "./ReportLead.vue?vue&type=script&lang=js&"
export * from "./ReportLead.vue?vue&type=script&lang=js&"
import style0 from "./ReportLead.vue?vue&type=style&index=0&id=3f596a8b&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3f596a8b",
  null
  
)

export default component.exports